<template>
  <b-sidebar
    :id="review ? `sidebar-edit-${review.id}` : 'sidebar-new'"
    :title="review ? $t('reviews.editTitle') : $t('reviews.new')"
    @shown="initReview"
    sidebar-class="bb-offcanvas-panel"
    bg-variant="white"
    header-class="createSidebar"
    right
    backdrop-variant="dark"
    backdrop
    shadow
    width="26.25rem"
  >
    <template>
      <!--//Titulo Revision-->
      <div v-if="!review" class="row form-row">
        <label
          class="label-form-review column col-sm-12 ng-scope form__label"
          :class="{
            error_color:
              submitForm && (!$v.title.required || !$v.title.minLength),
          }"
        >
          {{ $t("reviews.title") }}:
        </label>
        <div class="input-form-review col">
          <b-form-input
            :id="'title'"
            v-model.trim="title"
            :placeholder="$t('reviews.titlePlaceholder')"
          ></b-form-input>
          <div class="error" v-if="submitForm && !$v.title.required">
            {{ $t("errors.requiredTitle") }}
          </div>
          <div class="error" v-if="submitForm && !$v.title.minLength">
            {{ $t("errors.minLength") }} +
            {{ $v.title.$params.minLength.min }}
          </div>
        </div>
      </div>
      <!--//Titulo del Curso-->
      <div class="row form-row">
        <label class="label-form-review column col-sm-12 ng-scope form__label">
          {{ $t("reviews.courseName") }}:
        </label>
        <div class="input-form-review col">
          <label class="coursetitle"> {{ courseTitle }} </label>
        </div>
      </div>
      <!--//Organizador-->
      <div class="row form-row">
        <label class="label-form-review column col-sm-12 ng-scope form__label">
          {{ $t("reviews.organizedBy") }}:
        </label>
        <div class="input-form-review col">
          <label class="coursetitle"
            >{{ this.toUTF8(this.organizerName) }}
          </label>
        </div>
      </div>
      <!--//Descripcion-->
      <div class="row form-row">
        <label class="label-form-review column col-sm-12 ng-scope form__label">
          {{ $t("reviews.description") }}:
        </label>
        <div class="input-form-review col">
          <b-form-textarea
            :id="'description'"
            type="text"
            v-model="description"
          ></b-form-textarea>
        </div>
      </div>
      <!--//Check Notify Profesor-->
      <div>
        <div class="status-advice">
          <p>
            <b-icon-info-circle-fill />
            <strong>{{ $t("reviews.notify.title") }}: </strong
            >{{ $t("reviews.notify.text") }}
          </p>
        </div>
        <div class="repeteatSelector row">
          <div class="row waitingListLabel">
            <div class="input-form-review-waiting">
              <b-form-checkbox class="waitingListCheck" v-model="notify_active"
                >{{ $t("reviews.notify.enableNotifyTeacher") }}
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </div>
      <!--//Estado Revision-->
      <div class="row form-row" v-if="review">
        <label class="label-form-review column col-sm-12 ng-scope form__label">
          {{ $t("reviews.revisionStatus") }}:
        </label>
        <div class="input-form-review">
          <label class="coursetitle review-status">
            <span class="date">
              <span v-if="isOngoing(review)">
                <span class="session-ongoing" v-if="review.endDate">
                  {{ $t("reviews.inprogress") }}
                </span>
                <span class="session-ongoing" v-if="!review.endDate">
                  <bdi>{{ review.start | moment("D/M/YY HH:mm") }}</bdi>
                  {{ $t("reviews.inprogress") }}
                </span>
              </span>
              <span v-if="!isOngoing(review)">
                <span
                  class="session-not-started"
                  v-if="notYetStarted(review) && review.endDate"
                >
                  {{ $t("reviews.notstarted") }}
                </span>
                <span
                  class="session-not-started"
                  v-if="notYetStarted(review) && !review.endDate"
                >
                  {{ $t("reviews.notstarted") }}
                </span>
                <span class="session-not-started" v-if="hasEnded(review)">
                  <span class="session-ended">
                    {{ $t("reviews.finished") }}
                  </span>
                </span>
              </span>
            </span>
          </label>
        </div>
      </div>
      <!--//GRUPOS-->
      <div
        v-if="options_groups && !review"
        class="row form-row"
        :class="{ 'form-group--error': $v.selected_groups.$error }"
      >
        <label
          class="label-form-review column col-sm-12 ng-scope form__label"
          :class="{
            error_color: submitForm && !$v.selected_groups.required,
          }"
          >{{ $t("reviews.groups") }}</label
        >
        <div
          class="input-form-review col multiselect-select-style"
          v-if="!review"
        >
          <multiselect
            v-model="selected_groups"
            :loading="groupStore.loading"
            :options="groupStore.groups"
            :searchable="false"
            :closeOnSelect="true"
            :multiple="true"
            :placeholder="
              groupStore.loading
                ? $t('reviews.loading-goups')
                : $t('reviews.targetgroups')
            "
            :allow-empty="true"
            :hide-selected="true"
            :show-labels="false"
            track-by="groupLmsId"
            label="name"
            ><span slot="noResult">{{ $t("reviews.empty-groups") }}</span>
            <span slot="noOptions">{{ $t("reviews.empty-groups") }}</span>
            <template slot="tag" slot-scope="{ option, remove }">
              <div class="content-tag">
                <div class="option_tag">
                  <p class="truncate-text">{{ option.name }}</p>
                  <button>
                    <b-icon-x-circle
                      scale="1"
                      @click="remove(option)"
                    ></b-icon-x-circle>
                  </button>
                </div>
              </div>
            </template>
          </multiselect>
          <div class="error" v-if="submitForm & !$v.selected_groups.required">
            {{ $t("errors.emptyGroupsReview") }}
          </div>
        </div>
      </div>
      <!--//UBICACION-->
      <div class="row form-row">
        <label
          class="label-form-review column col-sm-12 ng-scope form__label"
          :class="{
            error_color:
              submitForm && (!$v.location.required || !$v.location.minLength),
          }"
        >
          {{ $t("reviews.location") }}
        </label>
        <div class="input-form-review col">
          <b-form-textarea
            :id="'location'"
            type="text"
            :placeholder="$t('reviews.locationPlaceholder')"
            v-model="location"
          ></b-form-textarea>
          <div class="error" v-if="submitForm && !$v.location.required">
            {{ $t("errors.emptyLocationReview") }}
          </div>
          <div class="error" v-if="submitForm && !$v.location.minLength">
            {{ $t("errors.minLength") }} +
            {{ $v.location.$params.minLength.min }}
          </div>
        </div>
      </div>
      <!--//Inicio Revision-->
      <div class="row form-row no-margin-bottom">
        <label
          class="label-form-review-dates column col-sm-12 ng-scope"
          :class="{ error_color: isStardDateNoOk }"
          bb-translate=""
          >{{ $t("reviews.star_date") }}:</label
        >
        <div class="input-form-review-dates row">
          <div class="picker-input date-first date column col-sm-6">
            <label
              class="date-hour-label column col-sm-12 ng-scope"
              :class="{ error_color: isStardDateNoOk }"
              bb-translate=""
              >{{ $t("reviews.star_date_init") }}:</label
            >
            <b-form-datepicker
              :disabled="isActualDateAfterInscriptionInitDate"
              start-weekday="1"
              today-button
              v-bind:label-today-button="$t('reviews.today')"
              reset-button
              v-bind:label-reset-button="$t('reviews.clear')"
              v-bind:label-help="$t('reviews.navigatemouse')"
              label-no-date-selected="-"
              :id="review ? 'start-date-' + review.id : 'start-date'"
              type="text"
              v-model="startDate"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              locale="es"
            >
              <template #button-content>
                <i
                    style="font-size: 16px"
                    class="isax isax-calendar-tick"
                    aria-hidden="true"
                ></i>
              </template>
            </b-form-datepicker>
          </div>
          <div class="picker-input date-last column col-sm-6">
            <label
              class="date-hour-label column col-sm-12 ng-scope"
              :class="{ error_color: isStardDateNoOk }"
              bb-translate=""
              >{{ $t("reviews.star_time_init") }}:</label
            >
            <b-form-timepicker
              :disabled="isActualDateAfterInscriptionInitDate"
              v-bind:label-close-button="$t('buttons.close')"
              label-no-time-selected="-"
              :id="review ? 'start-time-' + review.id : 'start-time'"
              type="text"
              v-model="start_time"
              locale="es"
            >
            </b-form-timepicker>
          </div>
          <div class="error" v-if="isStardDateNoOk">
            {{ $t("errors.startDateBeforeNow") }}
          </div>
        </div>
      </div>
      <!--//Fin Revision-->
      <div class="row form-row">
        <label
          class="label-form-review-dates column col-sm-12 ng-scope"
          :class="{ error_color: submitForm && isEndDateNoOk }"
          bb-translate=""
          >{{ $t("reviews.end_date") }}:</label
        >
        <div class="input-form-review-dates row">
          <div class="picker-input date-first date column col-sm-6">
            <label
              class="date-hour-label column col-sm-12 ng-scope"
              :class="{ error_color: submitForm && isEndDateNoOk }"
              bb-translate=""
              >{{ $t("reviews.end_date_fin") }}:</label
            >
            <b-form-datepicker
              :disabled="isActualDateAfterInscriptionInitDate"
              today-button
              start-weekday="1"
              v-bind:label-today-button="$t('reviews.today')"
              reset-button
              v-bind:label-reset-button="$t('reviews.clear')"
              v-bind:label-help="$t('reviews.navigatemouse')"
              label-no-date-selected="-"
              :id="review ? 'end-date-' + review.id : 'end-date'"
              type="text"
              v-model="endDate"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              locale="es"
            >
              <template #button-content>
                <i
                    style="font-size: 16px"
                    class="isax isax-calendar-tick"
                    aria-hidden="true"
                ></i>
              </template>
            </b-form-datepicker>
          </div>
          <div class="picker-input date-last column col-sm-6">
            <label
              class="date-hour-label column col-sm-12 ng-scope"
              :class="{ error_color: submitForm && isEndDateNoOk }"
              bb-translate=""
              >{{ $t("reviews.end_time_fin") }}:</label
            >
            <b-form-timepicker
              :disabled="isActualDateAfterInscriptionInitDate"
              v-bind:label-close-button="$t('buttons.close')"
              label-no-time-selected="-"
              :id="review ? 'end-time-' + review.id : 'end-time'"
              type="text"
              v-model="end_time"
              locale="es"
            >
            </b-form-timepicker>
          </div>
          <div class="error" v-if="isEndDateNoOk">
            {{ $t("errors.endDateBeforeNow") }}
          </div>
        </div>
      </div>
      <!--Inicio Tipo de review-->
      <!--//Tipo de Revision-->
      <div class="row form-row">
        <label class="label-form-review column col-sm-12 ng-scope form__label">
          {{ $t("reviews.reviewType") }}:
        </label>
        <div class="input-form-review col">
          <b-form-select
            :disabled="review"
            v-model="type"
            place-holder
            :value="type"
            :options="type_options"
          ></b-form-select>
        </div>
      </div>
      <!--Aviso Lista de espera-->
      <div class="status-advice">
        <p>
          <b-icon-info-circle-fill />
          <strong>{{ $t("reviews.waitingList.info-title") }}: </strong
          >{{ $t("reviews.waitingList.info") }}
        </p>
      </div>
      <!--Check Box Waiting list-->
      <div class="repeteatSelector row">
        <div class="row waitingListLabel">
          <div class="input-form-review-waiting">
            <b-form-checkbox
              class="waitingListCheck"
              :disabled="review && waitingList && signupListReviewsWaitList"
              v-show="parseInt(type) == 3 || parseInt(type) == 2"
              v-model="waitingList"
              >{{ $t("reviews.enableWaitingList") }}
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <!--Numero de Franjas Disponibles -->
      <div class="repeteatSelector-dates-inscription row" v-show="type == '3'">
        <div class="signupLayer flex align-items-center">
          <div class="align-left column inscriptionUnit">
            <label
              class="custom-select"
              :class="{
                error_color:
                  $v.numberOfInterval.$error || isNumberOfIntervalNoOk,
              }"
              >{{ $t("reviews.numPlacesDisp") }}
            </label>
          </div>
          <div class="inscriptionNumber-inscriptionUnit">
            <div class="column inscriptionNumber">
              <b-form-input
                :disabled="isActualDateAfterInscriptionInitDate"
                :id="'numberOfInterval'"
                type="number"
                v-model="numberOfInterval"
                pattern="^[0-9]+"
                :min="1"
              ></b-form-input>
            </div>
          </div>
          <label
            class="label-form-review"
            :class="{
              error_color:
                submitForm &&
                ((!review && isSignupStartNumberNumberNoOk) ||
                  (review && isSignupStartNumberNumberNoOk)),
            }"
            ><div
              class="error error-intervals-parti"
              v-if="submitForm && !review && isNumberOfIntervalNoOk"
            >
              {{ $t("errors.valueSupOne") }}
            </div>
            <div
              class="error error-intervals-parti"
              v-if="submitForm && review && isNumberOfIntervalNoOk"
            >
              {{ $t("errors.moreThanValue") }}
            </div></label
          >
        </div>
      </div>
      <!--N Max participantes por intervalo-->
      <div class="repeteatSelector-dates-inscription row" v-show="type == '3'">
        <div class="signupLayer align-items-center">
          <div class="inscriptionUnit">
            <label
              class="custom-select"
              :class="{
                error_color:
                  $v.participantsInInterval.$error ||
                  isParticipantsInIntervalNoOk,
              }"
            >
              {{ $t("reviews.partNumber") }}
            </label>
          </div>
          <div class="inscriptionNumber-inscriptionUnit">
            <div class="column inscriptionNumber">
              <b-form-input
                :id="'participantsInInterval'"
                type="number"
                v-model="participantsInInterval"
                pattern="^[0-9]+"
                :min="oldParticipantsInInterval"
              ></b-form-input>
            </div>
          </div>
          <label
            class="label-form-review"
            :class="{
              error_color:
                submitForm &&
                ((!review && isSignupStartNumberNumberNoOk) ||
                  (review && isSignupStartNumberNumberNoOk)),
            }"
            ><div
              class="error error-intervals-parti"
              v-if="submitForm && !review && isParticipantsInIntervalNoOk"
            >
              {{ $t("errors.valueSupOne") }}
            </div>
            <div
              class="error error-intervals-parti"
              v-if="submitForm && review && isParticipantsInIntervalNoOk"
            >
              {{ $t("errors.moreThanValue") }}
            </div></label
          >
        </div>
      </div>
      <!--MAX Asistentes en Franja Simple-->
      <div class="repeteatSelector-dates-inscription row" v-show="type == '2'">
        <div class="signupLayer align-items-center">
          <div class="inscriptionUnit">
            <label
              class="custom-select"
              :class="{
                error_color:
                  $v.maxParticipants.$error ||
                  (submitForm && isMaxParticipantsNoOk),
              }"
            >
              {{ $t("reviews.partMaxNum") }}
            </label>
          </div>
          <div class="inscriptionNumber-inscriptionUnit">
            <div class="column inscriptionNumber">
              <b-form-input
                :id="'maxParticipants'"
                type="number"
                v-model="maxParticipants"
                pattern="^[0-9]+"
                :min="1"
              ></b-form-input>
            </div>
          </div>
          <label
            class="label-form-review align-left"
            :class="{
              error_color:
                submitForm &&
                ((!review && isSignupStartNumberNumberNoOk) ||
                  (review && isSignupStartNumberNumberNoOk)),
            }"
            ><div
              class="error error-intervals-parti"
              v-if="submitForm && !review && isMaxParticipantsNoOk"
            >
              {{ $t("errors.valueSupOne") }}
            </div>
            <div
              class="error error-intervals-parti"
              v-if="submitForm && review && isMaxParticipantsNoOk"
            >
              {{ $t("errors.moreThanValue") }}
            </div>
          </label>
        </div>
      </div>
      <!--INICIO DE LA INSCRIPCION-->
      <div
        class="repeteatSelector-dates-inscription form-row mb-2 row"
        v-show="parseInt(type) > 1"
      >
        <div class="inscriptionUnit d-flex col-4 align-items-center">
          <label
            class="label-form-review flex align-items-center"
            :class="{
              error_color:
                submitForm &&
                ((!review && isSignupStartNumberNumberNoOk) ||
                  (review && isSignupStartNumberNumberNoOk)),
            }"
            >{{ $t("reviews.signup.begin") }}:</label
          >
        </div>
        <div class="column inscriptionNumber col-2" v-show="parseInt(type) > 1">
          <b-form-input
            :disabled="
              isActualDateAfterInscriptionInitDate || this.signupStartUnit == 0
            "
            :id="'signupStartNumber'"
            type="number"
            v-model="signupStartNumber"
            pattern="^[0-9]+"
            :min="1"
          ></b-form-input>
        </div>
        <div class="column inscriptionUnit col-6" v-show="parseInt(type) > 1">
          <b-form-select
            :disabled="isActualDateAfterInscriptionInitDate"
            :id="review ? 'signupStartUnit-' + review.id : 'signupStartUnit'"
            :value="signupStartUnit"
            v-model="signupStartUnit"
            :options="unit_options"
          >
            <b-form-select-option value="0"
              >{{ $t("reviews.startNow") }}
            </b-form-select-option>
          </b-form-select>
        </div>
        <div
          class="error"
          v-if="submitForm && !review && isSignupStartNumberNumberNoOk"
        >
          {{ $t("errors.valueSupOne") }}
        </div>
        <div
          class="error"
          v-if="submitForm && review && isSignupStartNumberNumberNoOk"
        >
          {{ $t("errors.moreThanValue") }}
        </div>
      </div>
      <!--FIN INSCRIPCION-->
      <div
        class="repeteatSelector-dates-inscription form-row mb-2 row"
        v-show="parseInt(type) > 1"
      >
        <div class="inscriptionUnit d-flex col-4 align-items-center">
          <label
            class="label-form-review flex align-items-center"
            :class="{
              error_color:
                submitForm &&
                ((!review && isSignupEndNumberNoOk) ||
                  (review && isSignupEndNumberNoOk) ||
                  (review && !isEndSubscriptionDateAfterNow) ||
                  isEndSubscriptionDateBeforeStart),
            }"
            >{{ $t("reviews.signup.end") }}:</label
          >
        </div>
        <div class="column inscriptionNumber col-2" v-show="parseInt(type) > 1">
          <b-form-input
            :id="'signupEndNumber'"
            type="number"
            :min="1"
            v-model="signupEndNumber"
            pattern="^[0-9]+"
          ></b-form-input>
        </div>
        <div class="column inscriptionUnit col-6">
          <b-form-select
            :id="review ? 'signupEndUnit-' + review.id : 'signupEndUnit'"
            v-model="signupEndUnit"
            :value="signupEndUnit"
            :options="unit_options"
          ></b-form-select>
        </div>
        <div class="error" v-if="submitForm && isSignupEndNumberNoOk">
          <p>{{ $t("errors.valueSupOne") }}</p>
          <p v-if="review">{{ $t("errors.noMinusDate") }}</p>
        </div>
        <div
          class="error"
          v-if="submitForm && review && !isEndSubscriptionDateAfterNow"
        >
          {{ $t("errors.moreThanNow") }}
        </div>
        <div class="error" v-if="isEndSubscriptionDateBeforeStart">
          {{ $t("errors.moreThanInit") }}
        </div>
      </div>
      <!--FIN Tipo de review-->
      <div v-if="!review">
        <div class="row form-row mt-4">
          <label
            class="label-form-review column col-sm-12 ng-scope form__label"
          >
            {{ $t("reviews.repetitions") }}:
          </label>
          <div class="input-form-review col ps-4">
            <b-form-select
              :id="review ? 'repeatFrecuency-' + review.id : 'repeatFrecuency'"
              v-model="repeatFrecuency"
              place-holder
              :value="repeatFrecuency"
              :options="repeat_frecuency_options"
            ></b-form-select>
          </div>
        </div>
        <div v-if="repeatFrecuency != 0" class="repeatType">
          <b-form-radio-group v-model="repeatType" class="repeatTypeGroup">
            <b-form-radio value="1" class="repeatTypeOption"
              >{{ $t("reviews.determinateNumberRepeats") }}
            </b-form-radio>
            <b-form-radio value="2" class="repeatTypeOption"
              >{{ $t("reviews.specificDate") }}
            </b-form-radio>
          </b-form-radio-group>
        </div>
        <div
          class="repeteatSelector-dates-inscription row my-4"
          v-if="repeatType == 1 && repeatFrecuency != 0"
        >
          <div class="signupLayer">
            <label
              style="margin-top: 7px"
              class="label-form-review"
              :class="{
                error_color:
                  submitForm &&
                  ($v.repeatEndIterations.$error ||
                    isRepeatEndIterationsNotSupZero),
              }"
            >
              <p>{{ $t("reviews.repetitionsNumber") }}:</p>
            </label>
            <div class="inscriptionNumber-inscriptionUnit">
              <div class="inscriptionUnit">
                <b-form-input
                  style="width: 60%"
                  :id="'repeatEndIterations'"
                  type="number"
                  :min="1"
                  v-model="repeatEndIterations"
                  pattern="^[0-9]+"
                ></b-form-input>
                <div class="column inscriptionNumber"></div>
                <div
                  class="error"
                  v-if="
                    submitForm &&
                    ($v.repeatEndIterations.$error ||
                      isRepeatEndIterationsNotSupZero)
                  "
                >
                  {{ $t("errors.valueSupOne") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Repeticiones hasta Fecha -->
        <div
          class="repeteatSelector-dates-inscription row"
          style="margin-top: 4px"
          v-if="repeatType == 2 && repeatFrecuency != 0"
        >
          <div class="signupLayer">
            <label
              style="margin-top: 7px"
              class="label-form-review"
              bb-translate=""
              :class="{
                error_color:
                  submitForm &&
                  parseInt(repeatType) == 2 &&
                  isRepeatEndDateBeforeStartDate,
              }"
              isRepeatEndDateBeforeStartDate
              >{{ $t("reviews.repeat_end_date") }}:</label
            >
            <div class="repeatToDate-unit">
              <b-form-datepicker
                style="margin-left: 16px"
                today-button
                start-weekday="1"
                v-bind:label-today-button="$t('reviews.today')"
                reset-button
                v-bind:label-reset-button="$t('reviews.clear')"
                v-bind:label-help="$t('reviews.navigatemouse')"
                label-no-date-selected="-"
                :id="review ? 'repeatEndDate' + review.id : 'repeatEndDate'"
                type="text"
                v-model="repeatEndDate"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="es"
                class="d-flex align-items-center"
              >
                <template #button-content>
                  <i
                    style="font-size: 16px"
                    class="isax isax-calendar-tick"
                    aria-hidden="true"
                  ></i>
                </template>
              </b-form-datepicker>
              <div
                class="error"
                v-if="
                  submitForm &&
                  parseInt(repeatType) == 2 &&
                  isRepeatEndDateBeforeStartDate
                "
              >
                {{ $t("errors.repeatEndDateBeforeStartDate") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer="{ hide }">
      <div class="save-buttons panel-footer">
        <div class="buttons-2 equal-buttons d-flex justify-content-between">
          <div class="col-sm-4 d-flex justify-content-start">
            <button
              class="button secondary cancel-button"
              v-on:click="
                hide;
                hideWindow();
              "
            >
              {{ $t("buttons.cancel") }}
            </button>
          </div>
          <div class="col-sm-4">
            <button class="button save-button" @click="updateReview">
              {{ $t("buttons.save") }}
            </button>
          </div>
        </div>
      </div>
    </template>
    <div class="status-advice">
      <p>
        <b-icon-info-circle-fill />
        <strong>{{ $t("reviews.advice-title") }}: </strong
        >{{ $t("reviews.advice-text") }}
      </p>
    </div>
  </b-sidebar>
</template>

<script>
import ReviewService from "@/service/review.js";
import DateService from "@/service/dates.js";
import LocationEnterIcon from "vue-material-design-icons/LocationEnter.vue";
import utilitiesMixin from "@/mixins/utilitiesMixin";
import jwtMixin from "@/mixins/jwtMixin";
import useUserState from "@/store/userState";
import useCourseState from "@/store/courseState";
import useGroupState from "@/store/groupState";
import Multiselect from "vue-multiselect";
import { minLength, minValue, requiredIf } from "vuelidate/lib/validators";
import { BIconInfoCircleFill, BIconX, BIconXCircle } from "bootstrap-vue";

export default {
  name: "EditReviewSidebar",
  // eslint-disable-next-line vue/no-unused-components
  components: {
    // eslint-disable-next-line vue/no-unused-components
    LocationEnterIcon,
    Multiselect,
    BIconX,
    BIconInfoCircleFill,
    BIconXCircle,
  },
  mixins: [utilitiesMixin, jwtMixin],
  props: ["review", "id", "groups"],
  async mounted() {
    this.$moment.locale(this.jwtLanguage());
    this.type = this.review ? this.review.type : 3;
    this.oldMaxParticipants = this.review ? this.review.oldMaxParticipants : 0;
    this.oldParticipantsInInterval = this.review
      ? this.review.oldParticipantsInInterval
      : 0;
  },
  async created() {
    this.$i18n.locale = this.jwtLanguage();
    this.$i18n.fallbackLocale = this.jwtLanguage();
    this.description = this.$i18n.t("reviews.descriptionPlaceholder");
  },
  data() {
    return {
      unit_options: [
        { value: 1, text: this.$i18n.t("reviews.minutes") },
        { value: 2, text: this.$i18n.t("reviews.hours") },
        { value: 3, text: this.$i18n.t("reviews.days") },
      ],
      repeat_frecuency_options: [
        { value: 0, text: this.$i18n.t("reviews.oneRepeat") },
        { value: 1, text: this.$i18n.t("reviews.dailyRepeat") },
        { value: 2, text: this.$i18n.t("reviews.weekRepeat") },
        { value: 3, text: this.$i18n.t("reviews.twoWeekRepeat") },
      ],
      type_options: [
        //        { value: 1, text: this.$i18n.t("reviews.openMeets") },
        { value: 3, text: this.$i18n.t("reviews.multipleIntervals") },
        { value: 2, text: this.$i18n.t("reviews.simpleInterval") },
      ],
      repeatType_options: [
        { value: 1, text: this.$i18n.t("reviews.determinateNumberRepeats") },
        { value: 2, text: this.$i18n.t("reviews.specificDate") },
      ],
      title: "",
      userStore: useUserState(),
      courseStore: useCourseState(),
      groupStore: useGroupState(),
      location: null,
      description: null,
      notify_active: false,
      startDate: null,
      start_time: null,
      endDate: null,
      end_time: null,
      numberOfInterval: 1,
      repeatFrecuency: 0,
      repeatEndDate: null,
      repeatEndIterations: 1,
      repeatNumberWeeks: null,
      signupStartNumber: 6,
      signupStartUnit: 3,
      signupStartNow: null,
      signupEndNumber: 1,
      signupEndUnit: 2,
      type: 0,
      maxParticipants: 1,
      repeatFrom: null,
      participantsInInterval: 1,
      viewParticipants: null,
      waitingList: false,
      publishInCalendar: null,
      intervalList: [],
      groupList: [],
      options_groups: [],
      selected_groups: [],
      repeatType: null,
      oldMaxParticipants: 0,
      oldParticipantsInInterval: 0,
      oldSignupStartNumber: 0,
      oldNumberOfInterval: 0,
      submitForm: false,
      isAfterStarDateTime: true,
      isAfterEndDateTime: true,
      signupListReviewsWaitList: false,
      oldSignupEndNumber: 1,
      oldSignupEndUnit: 2,
      courseTitle: null,
      organizerName: "",
    };
  },
  validations: {
    signupStartNumber: {
      required: requiredIf(function () {
        return !this.review;
      }),
      minValue: minValue(1),
    },
    signupEndNumber: {
      required: requiredIf(function () {
        return !this.review;
      }),
      minValue: minValue(1),
    },
    title: {
      required: requiredIf(function () {
        return !this.review;
      }),
      minLength: minLength(4),
    },
    location: {
      required: requiredIf(function () {
        return !this.review || this.review;
      }),
      minLength: minLength(4),
    },
    repeatFrecuency: {
      required: requiredIf(function () {
        return !this.review;
      }),
    },
    startDate: {
      required: requiredIf(function () {
        return !this.review;
      }),
      //    minValue: minValue(new Date()),
    },
    endDate: {
      required: requiredIf(function () {
        return !this.review;
      }),
    },
    participantsInInterval: {
      required: requiredIf(function () {
        return parseInt(this.type) == 3;
      }),
      minValue: minValue(1),
    },
    numberOfInterval: {
      required: requiredIf(function () {
        return parseInt(this.type) == 3;
      }),
      minValue: minValue(1),
    },
    maxParticipants: {
      required: requiredIf(function () {
        return parseInt(this.type) == 2;
      }),

      minValue: minValue(1),
    },
    selected_groups: {
      required: requiredIf(function () {
        return !this.review;
      }),
    },
    repeatEndDate: {
      required: requiredIf(function ({ repeatType }) {
        return this.repeatType && repeatType == "2";
      }),
    },
    repeatEndIterations: {
      required: requiredIf(function ({ repeatType }) {
        return this.repeatType && parseInt(repeatType) == 1;
      }),
    },
  },
  computed: {
    isRepeatEndIterationsNotSupZero() {
      return (
        !this.review &&
        parseInt(this.repeatType) == 1 &&
        (this.repeatEndIterations == null ||
          parseInt(this.repeatEndIterations) < 1)
      );
    },
    isActualDateAfterInscriptionInitDate() {
      let dateTime = window
        .moment(new Date())
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      if (this.review) {
        dateTime = window
          .moment(this.review.signupStartDate)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      }
      let dateTimeNow = window
        .moment(new Date())
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      return this.review && !window.moment(dateTime).isAfter(dateTimeNow);
    },
    isParticipantsInIntervalNoOk() {
      return (
        this.submitForm &&
        ((!this.review && this.participantsInInterval < 1) ||
          (this.review &&
            this.participantsInInterval < this.oldParticipantsInInterval))
      );
    },
    // eslint-disable-next-line vue/no-dupe-keys
    maxParticipants() {
      return this.review.participantsInInterval * this.review.numberOfInterval;
    },
    isMaxParticipantsNoOk() {
      return (
        this.submitForm &&
        ((!this.review && this.maxParticipants < 1) ||
          (this.review && this.maxParticipants < this.oldMaxParticipants))
      );
    },
    isNumberOfIntervalNoOk() {
      return (
        this.submitForm &&
        ((!this.review && this.numberOfInterval < 1) ||
          (this.review &&
            this.numberOfInterval <
              (this.oldNumberOfInterval == null
                ? 1
                : this.oldNumberOfInterval)))
      );
    },
    isRepeatEndDateBeforeStartDate() {
      const dateTime = this.toUtc(this.startDate, this.start_time);

      const repeatEndDateLocal = this.toUtc(this.repeatEndDate, "00:00");

      return (
        !this.review &&
        parseInt(this.repeatType) > 0 &&
        this.submitForm &&
        window.moment(dateTime).isAfter(repeatEndDateLocal)
      );
    },
    isStardDateNoOk() {
      let dateTime = this.toUtc(this.startDate, this.start_time);

      let dateTimeNow = window
        .moment(new Date())
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      return (
        !this.review &&
        this.submitForm &&
        !window.moment(dateTime).isAfter(dateTimeNow)
      );
    },
    isEndDateNoOk() {
      let dateTime = this.toUtc(this.startDate, this.start_time);

      let endDateTime = this.toUtc(this.endDate, this.end_time);

      return this.submitForm && !window.moment(endDateTime).isAfter(dateTime);
    },
    isEndSubscriptionDateBeforeStart() {
      let dateTime;
      if (this.review) {
        dateTime = window
          .moment(this.review.startDate)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      } else {
        dateTime = this.toUtc(this.startDate, this.start_time);
      }
      let inicio = this.calculateToDate(
        dateTime,
        this.signupStartNumber,
        this.signupStartUnit
      );
      let fin = this.calculateToDate(
        dateTime,
        this.signupEndNumber,
        this.signupEndUnit
      );
      return window.moment(inicio).isAfter(fin);
    },
    isEndSubscriptionDateAfterNow() {
      let dateTimeNow = window
        .moment(new Date())
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      if (
        (parseInt(this.type) === 3 || parseInt(this.type) === 2) &&
        this.isActualDateAfterInscriptionInitDate &&
        (parseInt(this.oldSignupEndUnit) !== parseInt(this.signupEndUnit) ||
          parseInt(this.oldSignupEndNumber) !== parseInt(this.signupEndNumber))
      ) {
        //Se calcula la hora del inicio de la inscripcion a partir de la fecha incial
        let plusEndUnit = null;
        if (parseInt(this.signupEndUnit) === 1) plusEndUnit = "m";
        if (parseInt(this.signupEndUnit) === 2) plusEndUnit = "h";
        if (parseInt(this.signupEndUnit) === 3) plusEndUnit = "d";
        const startUtc = this.toUtc(this.startDate, this.start_time);
        let endSubscribe = window
          .moment(startUtc)
          .subtract(parseInt(this.signupEndNumber), plusEndUnit)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
        // La fecha de fin de inscripción no puede ser anterior al dia de hoy
        if (!window.moment(endSubscribe).isAfter(dateTimeNow)) {
          return false;
        } else return true;
      }
      return true;
    },
    isSignupStartNumberNumberNoOk() {
      return parseInt(this.signupStartNumber) < 1;
    },
    isSignupEndNumberNoOk() {
      if (
        this.review &&
        (this.signupEndNumber == "" ||
          !(parseInt(this.signupEndNumber) >= 1) ||
          parseInt(this.signupEndNumber) > this.oldSignupEndNumber ||
          parseInt(this.signupEndUnit) > this.oldSignupEndUnit)
      )
        return true;
      if (!this.review && !(parseInt(this.signupEndNumber) >= 1)) return true;
      return false;
    },
  },
  watch: {
    type(newType) {
      if (!newType) {
        this.type = 3;
      }
    },
  },
  methods: {
    userTimezone() {
      return DateService.getUserTimezone();
    },
    toUtc(date, time) {
      return DateService.toUTC(date, time, this.userTimezone());
    },
    fromUtc(dateUtc, format = "YYYY-MM-DD HH:mm") {
      return DateService.utcToEvent(dateUtc, this.userTimezone(), format);
    },
    hideWindow() {
      // FJL: Se reinicia el modelo y la validación, se oculta el modal y se recarga la lista
      Object.assign(this.$data, this.$options.data.call(this));
      let vueComponent = this;
      vueComponent.$v.$reset();
      if (this.review) {
        this.$root.$emit(
          "bv::toggle::collapse",
          `sidebar-edit-${this.review.id}`
        );
        this.$emit("refresh");
        this.startDate = this.toUtc(this.startDate, this.start_time);
        this.endDate = this.toUtc(this.endDate, this.end_time);
      } else {
        this.$root.$emit("bv::toggle::collapse", "sidebar-new");
      }
    },
    updateReview() {
      this.submitForm = true;
      if (
        parseInt(this.type) === 3 &&
        parseInt(this.participantsInInterval) <
          (this.oldParticipantsInInterval == null
            ? 1
            : parseInt(this.oldParticipantsInInterval))
      ) {
        return;
      }
      if (
        parseInt(this.type) === 3 &&
        parseInt(this.numberOfInterval) <
          (this.oldNumberOfInterval == null
            ? 1
            : parseInt(this.oldNumberOfInterval))
      ) {
        return;
      }
      if (
        parseInt(this.type) === 2 &&
        this.maxParticipants < this.oldMaxParticipants
      ) {
        return;
      }
      let dateTime = this.toUtc(this.startDate, this.start_time);

      let endDateTime = this.toUtc(this.endDate, this.end_time);

      let dateTimeNow = window
        .moment(new Date())
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      this.isAfterStarDateTime = true;
      let isSignupStartNumberNumberNoOk = !(
        parseInt(this.signupStartNumber) >= 1
      );
      if (!this.review) {
        this.isAfterStarDateTime = window.moment(dateTime).isAfter(dateTimeNow);
      }

      let isSignupEndNumberNoOk = !(parseInt(this.signupEndNumber) >= 1);
      this.isAfterEndDateTime = window.moment(endDateTime).isAfter(dateTime);

      let repeatEndDateLocal = this.toUtc(this.repeatEndDate, "00:00");

      let isRepeatEndDateAfterStartDate = window
        .moment(dateTime)
        .isAfter(repeatEndDateLocal);

      if (
        !this.isAfterStarDateTime ||
        !this.isAfterEndDateTime ||
        isSignupStartNumberNumberNoOk ||
        isSignupEndNumberNoOk ||
        (!this.review &&
          parseInt(this.repeatFrecuency) > 0 &&
          parseInt(this.repeatType) === 2 &&
          isRepeatEndDateAfterStartDate)
      ) {
        return;
      }
      if (
        parseInt(this.repeatFrecuency) > 0 &&
        parseInt(this.repeatType) === 1 &&
        parseInt(this.repeatEndIterations) < 1
      ) {
        return;
      }
      //Validacion de fecha fin de fecha de isncripcion que sea posterior a la actual
      if (!this.isEndSubscriptionDateAfterNow) {
        return;
      }
      // Validación coherencia fechas de inscripcón
      if (this.isEndSubscriptionDateBeforeStart) return;
      if (this.isSignupEndNumberNoOk) return;
      let vueComponent = this;
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log(this.$v);
        return;
      }

      // FJL: Se distingue si se está actualizando una sesión o es una nueva
      if (this.review) {
        // FJL: Se establece la fecha y hora
        this.$set(
          this.review,
          "startDate",
          this.toUtc(this.startDate, this.start_time)
        );
        this.$set(
          this.review,
          "endDate",
          this.toUtc(this.endDate, this.end_time)
        );

        this.$set(this.review, "location", this.location);
        this.$set(this.review, "description", this.description);
        this.$set(this.review, "repeatFrecuency", this.repeatFrecuency);
        this.$set(this.review, "type", this.type);
        // SOlO CONFIGURA SI SE HA ELEGIDO EL MODO DE REPETICION PoR FECHA
        if (this.repeatType == 2)
          this.$set(
            this.review,
            "repeatEndDate",
            this.repeatEndDate ? this.toUtc(this.repeatEndDate, "00:00") : null
          );
        // SOLO SE CONFIGURA SI SE HA ELEGIDO EL MODE DE REPEICION POR OCURRENCIAS
        if (this.repeatType == 1)
          this.$set(
            this.review,
            "repeatEndIterations",
            this.repeatEndIterations
          );
        this.$set(this.review, "repeatNumberWeeks", this.repeatNumberWeeks);
        this.$set(this.review, "signupStartNumber", this.signupStartNumber);
        this.$set(this.review, "signupStartUnit", this.signupStartUnit);
        this.$set(this.review, "signupStartNow", this.signupStartNow);
        this.$set(this.review, "signupEndNumber", this.signupEndNumber);
        this.$set(this.review, "signupEndUnit", this.signupEndUnit);
        this.$set(this.review, "notify_active", this.notify_active);
        switch (this.type) {
          case "1":
            this.$set(this.review, "participantsInInterval", null);
            this.$set(this.review, "numberOfInterval", null);
            this.$set(this.review, "maxParticipants", null);
            break;

          case "2":
            // Se asigna el valor correspondiente y se eliminan aquellos que pertenecen a otros types
            this.$set(this.review, "maxParticipants", this.maxParticipants);
            this.$set(
              this.review,
              "participantsInInterval",
              this.maxParticipants
            );
            this.$set(this.review, "numberOfInterval", null);
            break;

          case "3": {
            const participantsInInterval =
              this.participantsInInterval == null
                ? 1
                : this.participantsInInterval;
            const numberOfInterval =
              this.numberOfInterval == null ? 1 : this.numberOfInterval;

            this.$set(
              this.review,
              "participantsInInterval",
              this.participantsInInterval
            );
            this.$set(this.review, "numberOfInterval", this.numberOfInterval);
            this.$set(
              this.review,
              "maxParticipants",
              participantsInInterval * numberOfInterval
            );
            break;
          }
        }
        this.$set(this.review, "repeatForm", this.repeatFrom);
        this.$set(this.review, "repeatFrecuency", this.repeatFrecuency);
        this.$set(this.review, "viewParticipants", this.viewParticipants);
        this.$set(this.review, "waitingList", this.waitingList);
        this.$set(this.review, "publishInCalendar", this.publishInCalendar);
        this.$set(this.review, "groupList", this.selected_groups);
        this.$set(this.review, "intervalList", this.intervalList);
        ReviewService.putReview(this.review.id, this.review).then(
          (response) => {
            if (response.status === 200) {
              this.$noty.success(this.$i18n.t("reviews.successsaveconf"), {
                timeout: 3000,
                progressBar: true,
              });
              Object.assign(this.$data, this.$options.data.call(this));
              vueComponent.$v.$reset();
              this.$root.$emit(
                "bv::toggle::collapse",
                `sidebar-edit-${this.review.id}`
              );
              this.startDate = this.toUtc(this.startDate, this.start_time);
              this.endDate = this.toUtc(this.endDate, this.end_time);
              this.$emit("childInitReviews");
            }
          }
        );
      } else {
        // FJL: Se crea una nueva sesión
        const groupsListUserLess = this.selected_groups.map((group) => {
          const cleangroup = { ...group };
          cleangroup.users = [];
          return cleangroup;
        });
        let newreview = {
          startDate: this.toUtc(this.startDate, this.start_time),
          endDate: this.toUtc(this.endDate, this.end_time),
          title: this.title,
          organaizer: this.userStore.id,
          location: this.location,
          description: this.description,
          lmsId: this.courseStore.site,
          repeatFrecuency: this.repeatFrecuency,
          repeatEndDate:
            this.repeatType == 2
              ? this.toUtc(this.repeatEndDate, "00:00")
              : null,
          repeatEndIterations:
            this.repeatType == 1 ? this.repeatEndIterations : null,
          repeatNumberWeeks: this.repeatNumberWeeks,
          signupStartNumber: this.type == 1 ? null : this.signupStartNumber,
          signupStartUnit: this.type == 1 ? null : this.signupStartUnit,
          signupStartNow: this.type == 1 ? null : this.signupStartNow,
          signupEndNumber: this.type == 1 ? null : this.signupEndNumber,
          signupEndUnit: this.type == 1 ? null : this.signupEndUnit,
          type: this.type,
          notify_active: this.notify_active,
          maxParticipants: this.maxParticipants,
          repeatFrom: this.repeatFrom,
          numberOfInterval: this.numberOfInterval,
          participantsInInterval: this.participantsInInterval,
          viewParticipants: this.viewParticipants,
          waitingList: this.waitingList,
          publishInCalendar: this.publishInCalendar,
          intervalList: [],
          groupList: groupsListUserLess,
        };
        console.log(groupsListUserLess);
        ReviewService.postReview(newreview)
          .then((response) => {
            if (response.status === 200) {
              this.$noty.success(vueComponent.$i18n.t("reviews.successsave"), {
                timeout: 3000,
                progressBar: true,
              });
              // FJL: Se reinicia el modelo y la validación, se oculta el modal y se recarga la lista
              Object.assign(this.$data, this.$options.data.call(this));
              vueComponent.$v.$reset();
              this.$root.$emit("bv::toggle::collapse", "sidebar-new");
              this.$emit("childInitReviews");
            }
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.$noty.error(this.$i18n.t("errors.error400"), {
                timeout: 3000,
                progressBar: true,
              });
            } else if (error.response.status === 500) {
              this.$noty.error(this.$i18n.t("errors.error500"), {
                timeout: 3000,
                progressBar: true,
              });
            }
          });
      }
      // Cualquiera sea el caso refresca la página
    },
    async initReview() {
      let now = window.moment().tz(this.userTimezone());
      this.courseTitle = this.jwtContextTitle();
      this.startDate = this.review
        ? this.fromUtc(this.review.startDate, "YYYY-MM-DD")
        : now.format("YYYY-MM-DD");
      this.start_time = this.review
        ? this.fromUtc(this.review.startDate, "HH:mm")
        : now.clone().add(1, "hours").format("HH:mm");
      this.endDate = this.review
        ? this.fromUtc(this.review.endDate, "YYYY-MM-DD")
        : now.format("YYYY-MM-DD");
      this.end_time = this.review
        ? this.fromUtc(this.review.endDate, "HH:mm")
        : now.clone().add(1, "hours").format("HH:mm");
      this.options_groups = await this.groups;
      this.repeatEndDate = this.review
        ? this.fromUtc(this.review.repeatEndDate, "YYYY-MM-DD")
        : now.format("YYYY-MM-DD");

      if (this.review) {
        this.organizerName = this.review.organizerName;
        let srtarDateAux = window.moment(this.review.startDate);
        let signupEndDate = window.moment(this.review.signupEndDate);

        if (srtarDateAux.diff(signupEndDate, "days") > 1) {
          this.singupEndDateUnit = "days";
          this.singupEndDateNumber = srtarDateAux.diff(signupEndDate, "days");
        } else if (srtarDateAux.diff(signupEndDate, "hours") > 1) {
          this.singupEndDateUnit = "hours";
          this.singupEndDateNumber = srtarDateAux.diff(signupEndDate, "hours");
        } else {
          this.singupEndDateUnit = "minutes";
          this.singupEndDateNumber = srtarDateAux.diff(
            signupEndDate,
            "minutes"
          );
        }
        this.title = this.review.title;
        this.description = this.review.description
          ? this.review.description
          : this.$i18n.t("reviews.descriptionPlaceholder");
        this.organaizer = this.review.organaizer;
        this.location = this.review.location;
        this.lmsId = this.review.lmsId;
        this.repeatFrecuency = this.review.repeatFrecuency;
        this.repeatEndIterations = this.review.repeatEndIterations;
        this.repeatNumberWeeks = this.review.repeatNumberWeeks;
        this.signupStartNumber = this.review.signupStartNumber;
        this.signupStartUnit = this.review.signupStartUnit;
        this.signupStartNow = this.review.signupStartNow;
        this.signupEndNumber = this.review.signupEndNumber;
        this.signupEndUnit = this.review.signupEndUnit;
        this.type = this.review.type.toString();
        this.maxParticipants = this.review.maxParticipants;
        this.repeatFrom = this.review.repeatFrom;
        this.numberOfInterval = this.review.intervalList.length;
        this.participantsInInterval = this.review.participantsInInterval;
        this.viewParticipants = this.review.viewParticipants;
        this.waitingList = this.review.waitingList;
        this.publishInCalendar = this.review.publishInCalendar;
        this.selected_groups = this.review.groupList;
        this.intervalList = this.review.intervalList;
        this.oldParticipantsInInterval = this.review.participantsInInterval;
        this.oldMaxParticipants = this.review.maxParticipants;
        this.oldSignupStartNumber = this.review.signupStartNumber;
        this.oldNumberOfInterval = this.review.intervalList.length;
        this.signupListReviewsWaitList = this.review.participansInwaitingList;
        this.oldSignupEndNumber = this.review.signupEndNumber;
        this.oldSignupEndUnit = this.review.signupEndUnit;
        this.notify_active = this.review.notify_active;
      } else {
        this.organizerName = this.userStore.userName;
        this.description = this.$i18n.t("reviews.descriptionPlaceholder");
        this.repeatType = 1;
        this.repeatEndIterations = 1;
      }
    },
  },
};
</script>
